import * as React from 'react';

function HowSkillSetsWork1(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={340} height={136} viewBox="0 0 340 136" fill="none" {...props}>
      <path fill="#F7F7F7" d="M0 0h340v136H0z" />
      <path d="M157.147 35.787V20.756l13.86-7.514 13.86 7.517v15.028l-13.86 7.513-13.86-7.513z" fill="#fff" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156 20.137L171.007 12 186 20.137V36.41l-14.993 8.137L156 36.407v-16.27zm27.713 1.243l-12.706-6.89-12.706 6.89v13.784l12.706 6.894 12.706-6.89V21.38z"
        fill="#EBA600"
      />
      <path
        d="M183.713 21.396l2.301-1.26V36.41l-2.305-1.25.004-13.764zM156 36.407l2.276-1.257 12.752 6.914-.021 2.48L156 36.406zM158.287 21.376L156 20.136 171.007 12l-.014 2.47-12.706 6.906z"
        fill="#FFC500"
      />
      <path
        d="M171.007 21.697l2.273 4.329 5.089.693-3.681 3.37.869 4.757-4.55-2.244-4.549 2.244.868-4.757-3.681-3.37 5.086-.693 2.276-4.329z"
        fill="#FFC500"
        stroke="#EBA600"
        strokeWidth={1.616}
        strokeLinecap="round"
      />
      <rect x={61.5} y={56.5} width={47} height={39} rx={1.5} fill="#fff" stroke="#BDBDBD" />
      <path stroke="#6A9DDB" strokeWidth={3} d="M66 63.5h25" />
      <path stroke="#979797" strokeWidth={3} d="M66 73.5h15" />
      <path stroke="#FFC300" strokeWidth={3} d="M94 73.5h5" />
      <path stroke="#979797" strokeWidth={3} d="M66 80.5h8" />
      <path stroke="#FFC300" strokeWidth={3} d="M94 87.5h5M94 80.5h7" />
      <path stroke="#979797" strokeWidth={3} d="M66 87.5h12" />
      <rect x={118.5} y={56.5} width={47} height={39} rx={1.5} fill="#fff" stroke="#BDBDBD" />
      <path stroke="#6A9DDB" strokeWidth={3} d="M123 63.5h25" />
      <path stroke="#979797" strokeWidth={3} d="M123 73.5h15" />
      <path stroke="#FFC300" strokeWidth={3} d="M151 73.5h5" />
      <path stroke="#979797" strokeWidth={3} d="M123 80.5h8" />
      <path stroke="#FFC300" strokeWidth={3} d="M151 87.5h5M151 80.5h7" />
      <path stroke="#979797" strokeWidth={3} d="M123 87.5h12" />
      <rect x={175.5} y={56.5} width={47} height={39} rx={1.5} fill="#fff" stroke="#BDBDBD" />
      <path stroke="#6A9DDB" strokeWidth={3} d="M180 63.5h25" />
      <path stroke="#979797" strokeWidth={3} d="M180 73.5h15" />
      <path stroke="#FFC300" strokeWidth={3} d="M208 73.5h5" />
      <path stroke="#979797" strokeWidth={3} d="M180 80.5h8" />
      <path stroke="#FFC300" strokeWidth={3} d="M208 87.5h5M208 80.5h7" />
      <path stroke="#979797" strokeWidth={3} d="M180 87.5h12" />
      <rect x={231.5} y={56.5} width={47} height={39} rx={1.5} fill="#fff" stroke="#BDBDBD" />
      <path stroke="#6A9DDB" strokeWidth={3} d="M236 63.5h25" />
      <path stroke="#979797" strokeWidth={3} d="M236 73.5h15" />
      <path stroke="#FFC300" strokeWidth={3} d="M264 73.5h5" />
      <path stroke="#979797" strokeWidth={3} d="M236 80.5h8" />
      <path stroke="#FFC300" strokeWidth={3} d="M264 87.5h5M264 80.5h7" />
      <path stroke="#979797" strokeWidth={3} d="M236 87.5h12" />
      <mask id="prefix__a" maskUnits="userSpaceOnUse" x={61} y={104} width={219} height={21}>
        <path fill="#C4C4C4" d="M61 104h219v21H61z" />
      </mask>
      <g mask="url(#prefix__a)">
        <rect x={61.5} y={104.5} width={47} height={39} rx={1.5} fill="#fff" stroke="#BDBDBD" />
        <path stroke="#6A9DDB" strokeWidth={3} d="M66 111.5h25" />
        <path stroke="#979797" strokeWidth={3} d="M66 121.5h15" />
        <path stroke="#FFC300" strokeWidth={3} d="M94 121.5h5" />
        <rect x={118.5} y={104.5} width={47} height={39} rx={1.5} fill="#fff" stroke="#BDBDBD" />
        <path stroke="#6A9DDB" strokeWidth={3} d="M123 111.5h25" />
        <path stroke="#979797" strokeWidth={3} d="M123 121.5h15" />
        <path stroke="#FFC300" strokeWidth={3} d="M151 121.5h5" />
        <rect x={175.5} y={104.5} width={47} height={39} rx={1.5} fill="#fff" stroke="#BDBDBD" />
        <path stroke="#6A9DDB" strokeWidth={3} d="M180 111.5h25" />
        <path stroke="#979797" strokeWidth={3} d="M180 121.5h15" />
        <path stroke="#FFC300" strokeWidth={3} d="M208 121.5h5" />
        <rect x={232.5} y={104.5} width={47} height={39} rx={1.5} fill="#fff" stroke="#BDBDBD" />
        <path stroke="#6A9DDB" strokeWidth={3} d="M237 111.5h25" />
        <path stroke="#979797" strokeWidth={3} d="M237 121.5h15" />
        <path stroke="#FFC300" strokeWidth={3} d="M265 121.5h5" />
      </g>
      <path stroke="#BDBDBD" d="M46 124.5h249" />
    </svg>
  );
}

export default HowSkillSetsWork1;
